import { useEffect, useState } from "react";
import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const QUESTIONS = [
  ["nouveau_client", "Il s'agit de sa première demande à l'aide juridique."],
  ["admis_12_mois", "Le requérant a été admis à l'aide juridique au cours des 12 derniers mois."],
  ["financiere_inchangee", "Sa situation financière ou familiale demeure la même."],
  ["sante_mentale", "Le requérant souffre de troubles de santé mentale."],
  ["detenu", "Le requérant est détenu."],
  ["vcvs", "Le requérant est dans un contexte de VCVS."],
  ["premieres_nations", "Le requérant est membre des premières nations."],
  ["immigration", "Le requérant fait une demande en droit de l'immigration."],
  ["cour_itinerante", "Le requérant a un dossier à la Cour itinérante (614, 625, 635, 640, 652)."],
  ["itinerance", "Le requérant est en situation d'itinérance."],
  ["aide_sociale", "Le requérant reçoit des prestations d'aide sociale ou de solidarité sociale (exclut PRB et objectif emploi)."],
  ["tiers_impossibilite", "Le requérant fait une demande au nom d'un tiers qui est dans l'impossibilité d'agir (art. 30 al.1)."],
  ["benefice_autrui", "Le requérant fait une demande pour un service pour le bénéfice d'autrui (art. 30 al.2)."],
];

export default function QuestionnaireLectureModal({ noSequence, noReg, noBur, onClose }) {
  const [data, setData] = useState(null);
  const [erreur, setErreur] = useState("");

  useEffect(() => {
    axios.get(`${API}/questionnaire/${encodeURIComponent(noSequence)}`, {
      params: { no_reg: noReg || "", no_bur: noBur || "" },
      withCredentials: true,
    })
      .then(r => setData(r.data))
      .catch(err => setErreur(err?.response?.data?.detail || "Erreur de chargement."));
  }, [noSequence, noReg, noBur]);

  const fmtDate = (iso) => iso ? iso.replace("T", " ").slice(0, 16) : "—";

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
                  display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1300 }}
         onClick={onClose}>
      <div style={{ background: "#f0f0f0", border: "1px solid #808080",
                    boxShadow: "3px 3px 8px rgba(0,0,0,0.3)", width: 940, maxWidth: "96vw" }}
           onClick={e => e.stopPropagation()}
           data-testid="questionnaire-lecture-modal">
        <div style={{ background: "linear-gradient(180deg,#1e5aa8,#164a8f)", color: "#fff",
                      padding: "8px 12px", fontWeight: 700, fontSize: 15,
                      display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>QUESTIONNAIRE DE VÉRIFICATION — LECTURE SEULE</span>
          <button className="win-modal-close" onClick={onClose}
                  data-testid="questionnaire-lecture-btn-x">×</button>
        </div>
        <div style={{ padding: 20, fontSize: 15 }}>
          {erreur ? (
            <p data-testid="questionnaire-lecture-erreur" style={{ margin: 0 }}>{erreur}</p>
          ) : !data ? (
            <p style={{ margin: 0 }}>Chargement...</p>
          ) : (
            <>
              <p style={{ marginTop: 0, marginBottom: 20, fontWeight: 700 }}>
                Demande {data.noseqdaj}{data.noclient ? ` — Client ${data.noclient}` : ""}
              </p>
              {QUESTIONS.map(([k, label]) => (
                <div key={k}
                     style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12,
                              whiteSpace: "nowrap", fontSize: 15 }}>
                  <input type="checkbox" checked={!!data[k]} disabled readOnly
                         data-testid={`questionnaire-lecture-${k.replace(/_/g, "-")}`}
                         style={{ width: 16, height: 16, flexShrink: 0 }} />
                  <span>{label}</span>
                </div>
              ))}
              <div style={{ marginTop: 20, padding: "12px 14px", background: "#e8e8e8",
                            border: "1px solid #c0c0c0", fontSize: 14 }}
                   data-testid="questionnaire-lecture-resultat">
                <div><b>Catégorie :</b> {data.categorie_id} — {data.categorie || "—"}</div>
                <div><b>Compteur au moment de la demande :</b> {data.compteur_cat}</div>
                <div>
                  <b>Client sélectionné pour vérification :</b>{" "}
                  {data.demande_docs
                    ? <span style={{ color: "#b00", fontWeight: 700 }}>Oui — documents de vérification requis (demande conditionnelle)</span>
                    : "Non"}
                </div>
                <div><b>Complété le :</b> {fmtDate(data.date_creation)} par {data.user_creation || "—"}</div>
              </div>
            </>
          )}
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
            <button className="win-btn" onClick={onClose}
                    data-testid="questionnaire-lecture-fermer">Fermer</button>
          </div>
        </div>
      </div>
    </div>
  );
}
